const TASK_LINE_RE = /^([ \t]*(?:[-*+]|\d+\.)[ \t]+)\[([ xX])\](.*)$/

function lineEnding(markdown: string): '\r\n' | '\n' {
  return markdown.includes('\r\n') ? '\r\n' : '\n'
}

function isFenceLine(line: string): { marker: string } | null {
  const m = line.match(/^(\s*)(`{3,}|~{3,})/)
  if (!m) return null
  return { marker: m[2] }
}

/**
 * Set the Nth GFM task (`- [ ]` / `- [x]`, also `*` `+` and numbered) to checked.
 * Skips fenced code blocks. Returns null when the index does not exist.
 */
export function setGfmTaskAtIndex(
  markdown: string,
  index: number,
  checked: boolean,
): string | null {
  if (!Number.isInteger(index) || index < 0) return null
  const nl = lineEnding(markdown)
  const lines = markdown.split(/\r?\n/)
  let inFence = false
  let fenceMarker = ''
  let taskI = 0

  for (let i = 0; i < lines.length; i++) {
    const fence = isFenceLine(lines[i])
    if (fence) {
      if (!inFence) {
        inFence = true
        fenceMarker = fence.marker
      } else if (lines[i].trim().startsWith(fenceMarker[0].repeat(fenceMarker.length))) {
        inFence = false
        fenceMarker = ''
      }
      continue
    }
    if (inFence) continue

    const m = lines[i].match(TASK_LINE_RE)
    if (!m) continue
    if (taskI === index) {
      const nextMark = checked ? 'x' : ' '
      lines[i] = `${m[1]}[${nextMark}]${m[3]}`
      return lines.join(nl)
    }
    taskI += 1
  }
  return null
}

export function toggleGfmTaskAtIndex(markdown: string, index: number): string | null {
  const current = getGfmTaskCheckedAtIndex(markdown, index)
  if (current === null) return null
  return setGfmTaskAtIndex(markdown, index, !current)
}

export function getGfmTaskCheckedAtIndex(markdown: string, index: number): boolean | null {
  if (!Number.isInteger(index) || index < 0) return null
  const lines = markdown.split(/\r?\n/)
  let inFence = false
  let fenceMarker = ''
  let taskI = 0

  for (let i = 0; i < lines.length; i++) {
    const fence = isFenceLine(lines[i])
    if (fence) {
      if (!inFence) {
        inFence = true
        fenceMarker = fence.marker
      } else if (lines[i].trim().startsWith(fenceMarker[0].repeat(fenceMarker.length))) {
        inFence = false
        fenceMarker = ''
      }
      continue
    }
    if (inFence) continue

    const m = lines[i].match(TASK_LINE_RE)
    if (!m) continue
    if (taskI === index) return m[2].toLowerCase() === 'x'
    taskI += 1
  }
  return null
}
